import {observer} from "mobx-react";
import {useOldRate} from "../../../infrastructure/hooks/rates/useOldRate";
import {OptionRate} from "./option-rate";

export const OptionOldRate = observer(({option, controller, className, betsImpressionParams}) => {
  const oldRate = useOldRate(controller, option);

  const optionRateProps = {
    controller,
    className,
    betsImpressionParams
  }

  return (
   <OptionRate {...optionRateProps}>
     {oldRate}
   </OptionRate>
  )
});

